export default {
  namespaced: true,
  holliday: {
    title: "feriado | feriados",
    date: "date",
  },
};
